export default __webpack_public_path__ + "static/media/Group 4930@2x.a5142d60.png";